import { rfqQuoteDetailsInformationStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation";
import { css } from "styled-components";

Object.assign(rfqQuoteDetailsInformationStyles, {
    expirationDateDatePicker: {
        cssOverrides: {
            datePicker: css`
                width: 200px;
                .react-datetime-picker {
                    border-radius: 4px !important;
                    > div > div[class="react-datetime-picker__inputGroup"] {
                        pointer-events: none !important;
                    }
                }
                div[class^="react-calendar"] {
                    right: auto !important;
                }
            `,
        },
    },
    expirationDateGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
            font-size: 14px;
        `,
    },
    expirationDateLabelText: { weight: 600, size: 16 },
    jobNameHeadingAndText: {
        heading: { transform: "initial", weight: 600, size: 16 },
        text: { transform: "initial", size: 14 },
    },
    salesRepHeadingAndText: {
        heading: { transform: "initial", weight: 600, size: 16 },
        text: { transform: "initial", size: 14 },
    },
    userHeadingAndText: {
        heading: { transform: "initial", weight: 600, size: 16 },
        text: { transform: "initial", size: 14 },
    },
    statusHeadingAndText: {
        heading: { transform: "initial", weight: 600, size: 16 },
        text: { transform: "initial", size: 14 },
    },
    dateGridItem: {
        width: [6, 6, 4, 4, 4],
        css: css`
            flex-direction: column;
            font-size: 14px;
        `,
    },
    dateLabelText: { weight: 600, size: 16 },
    customerHeadingAndText: {
        heading: { transform: "initial", weight: 600, size: 16 },
        text: { transform: "initial", size: 14 },
    },
    shipToHeadingAndText: {
        heading: { transform: "initial", weight: 600, size: 16 },
        text: { transform: "initial", size: 14 },
    },
});
